<script setup lang="ts">
import noop from 'lodash/noop'
import { type Component } from 'vue'

defineProps<{
  title: string
  subtitle: string
  icon: Component
}>()

// we need some dummy JS code to get sourcemaps generated
// https://github.com/cenfun/monocart-reporter/issues/33#issuecomment-1594033026
noop()
</script>

<template>
  <div class="w-2/3 xl:w-1/2 my-8 flex items-center">
    <div class="bg-slate-800 p-3 rounded-lg flex items-center justify-center">
      <component :is="icon" class="text-2xl text-white" />
    </div>

    <div class="ml-4 flex flex-col">
      <div class="text-white text-xl font-medium">
        {{ title }}
      </div>
      <div class="text-gray-100 text-sm mt-2">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>
